export function isNil(value: unknown): boolean {
  return value === undefined || value === null || Number.isNaN(value as any)
}

export function isNilOrEmptyString(value: unknown): boolean {
  return isNil(value) || value === ''
}
